import React from 'react';
import { convertFahrenheit } from '../../components/utils/TemperatureConversion';
import CommonDataManager from '../../components/CommonDataManager';


function visibleTemperature(props) {
    switch (props.Status) {
        case 0: return -1;
        case 1: return -1;
        case 2: return 0;
        case 3: return 0;
        case 4: return 0;
        case 5: return 0;
        case 6: return -1;

        default: return -1;
    }

}

export function tOvenTemplate(props) {

    let commonData = CommonDataManager.getInstance();
    let umTemperature = commonData.getUmTemperature();

    try {

        let tOven = props.TOven;
        if ((tOven === null) || (visibleTemperature(props) === -1))
            return (
                <div></div>
            );
        else
            if (umTemperature === 'F')
                tOven = convertFahrenheit(tOven)
        return (
            <div>{tOven}°{umTemperature}</div>
        );

    }
    catch (exp) {
        return (
            <div></div>
        );
    }

}

export function tFridgeTemplate(props) {

    let commonData = CommonDataManager.getInstance();
    let umTemperature = commonData.getUmTemperature();

    try {

        let tFridge = props.TFridge;
        if ((tFridge === null) || (visibleTemperature(props) === -1))
            return (
                <div></div>
            );
        else
            if (umTemperature === 'F')
                tFridge = convertFahrenheit(tFridge)
        return (
            <div>{tFridge}°{umTemperature}</div>
        );

    }
    catch (exp) {
        return (
            <div></div>
        );
    }
}